import * as actionType from "../constants/systemSettings";

const initialState = {
  loading: false,
  saving: false,
  syncing: false,
  settings: {},
  fetchSuccess: false,
  saveSuccess: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.SETTINGS_FETCH_START:
      return { ...state, loading: true, fetchSuccess: false };
    case actionType.SETTINGS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        fetchSuccess: true,
        settings: action.payload,
      };
    case actionType.SETTINGS_FETCH_FAIL:
      return { ...state, loading: false, fetchSuccess: false, error: action.payload };

    case actionType.SETTINGS_SAVE_START:
      return { ...state, saving: true, saveSuccess: false };
    case actionType.SETTINGS_SAVE_SUCCESS:
      return { ...state, saving: false, saveSuccess: true };
    case actionType.SETTINGS_SAVE_FAIL:
      return { ...state, saving: false, saveSuccess: false, error: action.payload };

    case actionType.SETTINGS_SYNC_ENV_START:
      return { ...state, syncing: true };
    case actionType.SETTINGS_SYNC_ENV_SUCCESS:
      return { ...state, syncing: false };
    case actionType.SETTINGS_SYNC_ENV_FAIL:
      return { ...state, syncing: false, error: action.payload };

    default:
      return state;
  }
};
